exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:1024px){.snow{z-index:-1;width:274px;height:72px;top:0;background:none;font-family:Androgyne;background-image:url(" + require("../../images/events/newyear/snow1.png") + "),url(" + require("../../images/events/newyear/snow2.png") + "),url(" + require("../../images/events/newyear/snow3.png") + ");position:absolute;animation:snowly 5s linear infinite}}.july4.logo img{margin:-10px 0 0;display:none}.july4.logo .event-logo,.sticky .july4 img{display:block}.sticky .july4 .event-logo{display:none}@media (min-width:1024px){.july4.logo img{margin:-25px 0 0 -15px}.event-logo{margin-top:-30px}}@keyframes snowly{0%{background-position:0 0,0 0,0 0}to{background-position:0 300px,200px 400px,-100px 300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!./css/stylus/_events.styl
// module id = 569
// module chunks = 2